export enum SettingsKey {
	PARTNERS_NEW_LEAD_SMS_TEXT = 'partners_new_lead_sms_text',
}
